<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>

  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
        <h4 class="card-title mb-0">Items</h4>
        <div class="d-flex align-items-center gap-3">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search items..."
            style="min-width:200px"
            (input)="onSearch($event)"
          />
          <button *ngIf="canAdd" class="btn btn-primary btn-sm" (click)="openCreateModal()">
            + Add Item
          </button>
        </div>
      </div>

      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table mb-0 table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Icon</th>
                <th class="text-center">Status</th>
                <th class="text-end pe-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="isLoading">
                <td colspan="5" class="text-center py-4">Loading...</td>
              </tr>
              <tr *ngIf="!isLoading && items.length === 0">
                <td colspan="5" class="text-center py-4 text-muted">No items found.</td>
              </tr>
              <tr *ngFor="let item of items; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.item_name }}</td>
                <td>
                  <span *ngIf="item.item_icon" class="text-muted small">{{ item.item_icon }}</span>
                  <span *ngIf="!item.item_icon" class="text-muted">—</span>
                </td>
                <td class="text-center">
                  <span class="badge badge-sm" [ngClass]="item.is_active ? 'badge-success' : 'badge-danger'">
                    {{ item.is_active ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td class="text-end pe-4">
                  <button *ngIf="canEdit" class="btn btn-xs btn-outline-primary me-2" (click)="openEditModal(item)">Edit</button>
                  <button *ngIf="canDelete" class="btn btn-xs btn-outline-danger" (click)="deleteItem(item)">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create / Edit Modal -->
<div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showModal"
  style="background:rgba(0,0,0,0.5)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit Item' : 'Add Item' }}</h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="itemForm" autocomplete="off">
          <!-- Item Name -->
          <div class="mb-3">
            <label class="form-label">Item Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="item_name"
              placeholder="e.g. Ceiling Fan"
              [ngClass]="{'is-invalid': itemForm.get('item_name')?.invalid && itemForm.get('item_name')?.touched}"
            />
            <div class="invalid-feedback">Name is required (2–100 characters).</div>
          </div>

          <!-- Item Icon -->
          <div class="mb-3">
            <label class="form-label">Icon <span class="text-muted small">(optional)</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="item_icon"
              placeholder="e.g. fa-fan"
              [ngClass]="{'is-invalid': itemForm.get('item_icon')?.invalid && itemForm.get('item_icon')?.touched}"
            />
            <div class="invalid-feedback">Max 100 characters.</div>
          </div>

          <!-- Active Toggle -->
          <div class="mb-3 d-flex align-items-center justify-content-between">
            <label class="form-label mb-0">Active</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" formControlName="is_active" />
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveItem()">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</div>
